import { render, staticRenderFns } from "./abk-agpz.vue?vue&type=template&id=db711850"
import script from "./abk-agpz.vue?vue&type=script&lang=js"
export * from "./abk-agpz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports